import { BrainIcon } from "../assets/icons";
import classes from "./Pages.module.css";

export default function LoadingPage() {
  return (
    <div className={classes.continer}>
      <div className={classes.logo}>
        <BrainIcon />
        <div className="logoText">Brain</div>
      </div>
      <div className={classes.loginButton}>
        Checking credentials...
      </div>
    </div>
  );
}
